/**
 * Helpery do PWA install hint:
 *  - `getPlatform()` rozpoznaje iOS / Android / desktop. iPad na iOS 13+
 *    podaje `MacIntel` w `navigator.platform`, więc fallback na `maxTouchPoints`.
 *  - `isStandalone()` true gdy apka działa jako zainstalowana PWA — banner
 *    install nie ma już sensu.
 *  - `isIosSafari()` rozróżnia Safari od Chrome/Firefox/Edge na iOS. Tylko
 *    Safari ma "Add to Home Screen" — w pozostałych przeglądarkach iOS
 *    instalacja PWA jest niemożliwa (ograniczenie Apple).
 */

export type Platform = "ios" | "android" | "desktop";

export function getPlatform(): Platform {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent || "";
  if (/iphone|ipad|ipod/i.test(ua)) return "ios";
  // iPadOS 13+ udaje desktop Safari (UA = "Macintosh"). Touch points > 1 to
  // jedyny pewny sygnał że to iPad.
  if (
    navigator.platform === "MacIntel" &&
    typeof navigator.maxTouchPoints === "number" &&
    navigator.maxTouchPoints > 1
  ) {
    return "ios";
  }
  if (/android/i.test(ua)) return "android";
  return "desktop";
}

export function isStandalone(): boolean {
  if (typeof window === "undefined") return false;
  if (window.matchMedia?.("(display-mode: standalone)").matches) return true;
  // iOS Safari używa własnej (niestandardowej) flagi `navigator.standalone`.
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true;
}

export function isIosSafari(): boolean {
  if (getPlatform() !== "ios") return false;
  const ua = navigator.userAgent || "";
  // CriOS / FxiOS / EdgiOS = Chrome / Firefox / Edge na iOS — bazują na
  // WebKit ale nie wystawiają "Add to Home Screen".
  return !/crios|fxios|edgios/i.test(ua);
}
